/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import React from "react";
import Grid from "@mui/material/Grid";
import summaryStyle from "../summaryStyle";
import Typography from "@mui/material/Typography";
import SummaryDetailsItem from "../../Common/SummaryDetailsItem/SummaryDetailsItem";
import { AbstractCase } from "../../../../types/Entities/AbstractCase";

type DivorceProps = {
  product: AbstractCase;
};
const Divorce = ({ product }: DivorceProps) => {
  return (
    <>
      <Grid sx={summaryStyle.subHeadline} size={12}>
        <Typography variant={"h5"}>Ehe und Scheidung</Typography>
      </Grid>
      <SummaryDetailsItem caseData={product} fieldPath={"dateMarriage"} fieldType={"date"} />
      <SummaryDetailsItem caseData={product} fieldPath={"cityMarriage"} />
      <SummaryDetailsItem caseData={product} fieldPath={"numberChildren"} />
      <SummaryDetailsItem caseData={product} fieldPath={"statusDivorce"} />
      <SummaryDetailsItem caseData={product} fieldPath={"dateSeparation"} fieldType={"date"} />
      <SummaryDetailsItem caseData={product} fieldPath={"movedOut"} />
      {product.movedOut !== "nobody" && <SummaryDetailsItem caseData={product} fieldPath={"dateMovedOut"} fieldType={"date"} />}
    </>
  );
};

export default Divorce;
